var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout", class: { layoutLogin: !_vm.headerShow } },
    [
      _c(
        "Layout",
        [
          _vm.headerShow
            ? _c("Header", [
                _c("div", { staticClass: "loginHead haveLoggedIn" }, [
                  _c(
                    "div",
                    { staticClass: "loginImg clearfix" },
                    [
                      _c("div", { staticClass: "layout-logo" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/login/ip_logo.png"),
                            alt: ""
                          },
                          on: { click: _vm.toHomePage }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sensors",
                                rawName: "v-sensors",
                                value: {
                                  type: "ClickNavigationBar",
                                  event: "click",
                                  getParams: function() {
                                    return { navigation_bar_name: "首页" }
                                  }
                                },
                                expression:
                                  "{\n                type: 'ClickNavigationBar',\n                event: 'click',\n                getParams: () => {\n                  return { navigation_bar_name: '首页' };\n                },\n              }"
                              }
                            ],
                            on: { click: _vm.toHomePage }
                          },
                          [_vm._v("首页")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sensors",
                                rawName: "v-sensors",
                                value: {
                                  type: "ClickNavigationBar",
                                  event: "click",
                                  getParams: function() {
                                    return { navigation_bar_name: "商标查询" }
                                  }
                                },
                                expression:
                                  "{\n                type: 'ClickNavigationBar',\n                event: 'click',\n                getParams: () => {\n                  return { navigation_bar_name: '商标查询' };\n                },\n              }"
                              }
                            ],
                            on: { click: _vm.goSearch }
                          },
                          [_vm._v("商标查询")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "go-bread",
                            class: _vm.isHoverProduct
                              ? "active"
                              : _vm.isInfoDetail
                              ? "active"
                              : "",
                            on: {
                              mouseover: function($event) {
                                _vm.isHoverProduct = true
                              },
                              mouseout: function($event) {
                                _vm.isHoverProduct = false
                              },
                              click: function($event) {
                                return _vm.$router.push({
                                  path: "/serviceDetail"
                                })
                              }
                            }
                          },
                          [
                            _vm._v("商标服务\n              "),
                            _c("img", {
                              staticClass: "hot",
                              attrs: {
                                src: require("@/assets/images/header/hot.svg"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isHoverProduct,
                                  expression: "!isHoverProduct"
                                }
                              ],
                              attrs: {
                                src: require("@/assets/images/header/gray-close.svg"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isHoverProduct,
                                  expression: "isHoverProduct"
                                },
                                {
                                  name: "sensors",
                                  rawName: "v-sensors",
                                  value: {
                                    type: "ClickNavigationBar",
                                    event: "click",
                                    getParams: function() {
                                      return { navigation_bar_name: "商标服务" }
                                    }
                                  },
                                  expression:
                                    "{\n                  type: 'ClickNavigationBar',\n                  event: 'click',\n                  getParams: () => {\n                    return { navigation_bar_name: '商标服务' };\n                  },\n                }"
                                }
                              ],
                              attrs: {
                                src: require("@/assets/images/header/blue-open.svg"),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "go-bread",
                            class: _vm.isHoverPatent
                              ? "active"
                              : _vm.isInfoPatent
                              ? "active"
                              : "",
                            on: {
                              mouseover: function($event) {
                                _vm.isHoverPatent = true
                              },
                              mouseout: function($event) {
                                _vm.isHoverPatent = false
                              }
                            }
                          },
                          [
                            _vm._v("国际外观专利\n              "),
                            _c("img", {
                              staticClass: "hot",
                              attrs: {
                                src: require("@/assets/images/header/hot.svg"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isHoverPatent,
                                  expression: "!isHoverPatent"
                                }
                              ],
                              attrs: {
                                src: require("@/assets/images/header/gray-close.svg"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isHoverPatent,
                                  expression: "isHoverPatent"
                                },
                                {
                                  name: "sensors",
                                  rawName: "v-sensors",
                                  value: {
                                    type: "ClickNavigationBar",
                                    event: "click",
                                    getParams: function() {
                                      return {
                                        navigation_bar_name: "国际外观专利"
                                      }
                                    }
                                  },
                                  expression:
                                    "{\n                  type: 'ClickNavigationBar',\n                  event: 'click',\n                  getParams: () => {\n                    return { navigation_bar_name: '国际外观专利' };\n                  },\n                }"
                                }
                              ],
                              attrs: {
                                src: require("@/assets/images/header/blue-open.svg"),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sensors",
                                rawName: "v-sensors",
                                value: {
                                  type: "ClickNavigationBar",
                                  event: "click",
                                  getParams: function() {
                                    return { navigation_bar_name: "知产百科" }
                                  }
                                },
                                expression:
                                  "{\n                type: 'ClickNavigationBar',\n                event: 'click',\n                getParams: () => {\n                  return { navigation_bar_name: '知产百科' };\n                },\n              }"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.goHomePage("news")
                              }
                            }
                          },
                          [_vm._v("知产百科")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sensors",
                                rawName: "v-sensors",
                                value: {
                                  type: "ClickNavigationBar",
                                  event: "click",
                                  getParams: function() {
                                    return { navigation_bar_name: "操作指引" }
                                  }
                                },
                                expression:
                                  "{\n                type: 'ClickNavigationBar',\n                event: 'click',\n                getParams: () => {\n                  return { navigation_bar_name: '操作指引' };\n                },\n              }"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.goHomePage("guide")
                              }
                            }
                          },
                          [_vm._v("操作指引")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sensors",
                                rawName: "v-sensors",
                                value: {
                                  type: "ClickNavigationBar",
                                  event: "click",
                                  getParams: function() {
                                    return { navigation_bar_name: "关于我们" }
                                  }
                                },
                                expression:
                                  "{\n                type: 'ClickNavigationBar',\n                event: 'click',\n                getParams: () => {\n                  return { navigation_bar_name: '关于我们' };\n                },\n              }"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.goHomePage("about")
                              }
                            }
                          },
                          [_vm._v("关于我们")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.iflogin
                        ? _c(
                            "Menu",
                            {
                              attrs: { mode: "horizontal", "active-name": "1" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "car",
                                  on: { click: _vm.goShopingCar }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "vertical-align": "middle" },
                                    attrs: {
                                      src: require("@/assets/images/common/gouwuche.svg"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("购物车")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v(_vm._s(_vm.carNum))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "photoAva" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "nickname" },
                                    [
                                      _c(
                                        "Submenu",
                                        { attrs: { name: "3" } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(_vm._s(_vm.nickName))
                                          ]),
                                          _vm._v(" "),
                                          _c("CompInfo", {
                                            attrs: { info: _vm.infos },
                                            on: { out: _vm.loout }
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Dropdown",
                                    { staticClass: "ava-box" },
                                    [
                                      _vm.isDefault
                                        ? _c("img", {
                                            staticClass: "avaImg",
                                            attrs: {
                                              src: require("@/assets/images/common/defaultImg.png"),
                                              alt: ""
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isDefault
                                        ? _c("img", {
                                            staticClass: "avaImg",
                                            attrs: {
                                              src: _vm.photoImg,
                                              alt: ""
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "DropdownMenu",
                                        {
                                          attrs: { slot: "list" },
                                          slot: "list"
                                        },
                                        [
                                          _c(
                                            "DropdownItem",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkPage(
                                                    2,
                                                    "orderList"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("购买记录")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "DropdownItem",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkPage(
                                                    2,
                                                    "myPatent"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("我的专利")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "DropdownItem",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkPage(
                                                    2,
                                                    "myBrand"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("商标注册")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "DropdownItem",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkPage(
                                                    2,
                                                    "coupon"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("优惠券")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "DropdownItem",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkPage(
                                                    2,
                                                    "user"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("个人信息")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ],
                                1
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "loginbtn" },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.goLogin }
                                },
                                [_vm._v("登录")]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "auto-box" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHoverProduct,
                          expression: "isHoverProduct"
                        }
                      ],
                      staticClass: "service-box",
                      on: {
                        mouseover: function($event) {
                          _vm.isHoverProduct = true
                        },
                        mouseout: function($event) {
                          _vm.isHoverProduct = false
                        }
                      }
                    },
                    _vm._l(_vm.serviceList, function(item, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "sensors",
                              rawName: "v-sensors",
                              value: {
                                type: "BrandServeView",
                                event: "click",
                                getParams: function() {
                                  return _vm.brandServeView(item)
                                }
                              },
                              expression:
                                "{\n              type: 'BrandServeView',\n              event: 'click',\n              getParams: () => brandServeView(item),\n            }"
                            }
                          ],
                          key: index,
                          staticClass: "item-boxs"
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadNavClick(item)
                                }
                              }
                            },
                            [
                              _c("img", { attrs: { src: item.img } }),
                              _vm._v(" "),
                              item.labelImg
                                ? _c("img", {
                                    staticClass: "label-img",
                                    attrs: { src: item.labelImg }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "p",
                                { class: item.isSell ? "" : "underline" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.country) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHoverPatent,
                          expression: "isHoverPatent"
                        }
                      ],
                      staticClass: "service-box",
                      on: {
                        mouseover: function($event) {
                          _vm.isHoverPatent = true
                        },
                        mouseout: function($event) {
                          _vm.isHoverPatent = false
                        }
                      }
                    },
                    _vm._l(_vm.patentList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item-boxs" },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadNavClick(item, "patent")
                                }
                              }
                            },
                            [
                              _c("img", { attrs: { src: item.img } }),
                              _vm._v(" "),
                              item.labelImg
                                ? _c("img", {
                                    staticClass: "label-img",
                                    attrs: { src: item.labelImg }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "p",
                                { class: item.isSell ? "" : "underline" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.country) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af5d225e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af5d225e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = null
// module chunks = 